import { Col, Container, Image, Row } from "react-bootstrap";
// import pic from "../../../assets/images/home/compeny-logo.svg";
import Accordion from "react-bootstrap/Accordion";
import { toWebp } from "../../../utils/common";
import React, { useState } from "react";
import { useRouter } from "next/router";

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
import styles from "./style.module.scss";

const Developer = ({ data, reference = null }) => {
	console.log("🚀 ~ Developer ~ data:", data)
	const router = useRouter();
	const [activeAccordionIndex, setActiveAccordionIndex] = useState(0);
	const mobileAccordions = data?.table_rows?.[0]?.points;
	const areColumnsMoreThenThree = data?.table_rows[0]?.points.length > 2;

	return (
		<section
			className={`${styles["developer-new-section"]} ${styles["technology-developer-section"]
				} ${styles["rfp-developer-section"]} ${reference == "rfp" ? styles["rfp-section"] : ""
				} bg-one home-padding-new `}
		>
			<Container className={styles["container"]}>
				<Row className="justify-content-center">
					<Col lg={8} md={10}>
						<div className={styles["developer-heading-content"]}>
							<h2 className="text-black">{data.title}</h2>
						</div>
					</Col>
				</Row>

				<div
					className={`d-none d-sm-none d-md-block d-lg-block ${styles["developer-table"]
						} ${areColumnsMoreThenThree && styles["column-table-4"]}`}
				>
					{data?.table_rows?.map((row, index) => {
						if (index === 0) {
							return (
								<ul
									key={row?.id}
									className={styles["developer-table-list"]}
								>
									<li className="text-medium font-semibold text-black">
										{row?.title}
									</li>
									{row?.points?.map((point) => (
										<li
											key={point.id}
											className={`text-medium font-semibold ${styles["developer-list-blue"]}`}
										>
											<div
												className={
													styles["developer-list-box"]
												}
											>
												<div
													className={
														styles[
														"next-project-profile"
														]
													}
												>
													<Image
														src={toWebp(
															`${baseUrl}${point?.image?.data?.attributes?.url}`
														)}
														alt={
															point?.image?.data
																?.attributes
																?.name
														}
													/>
												</div>
												<span></span>
											</div>
											{point?.title}
										</li>
									))}
								</ul>
							);
						}

						else if (index + 1 === data?.table_rows.length) {
							const hasValidButton = row?.points?.some(
								(point) =>
									point?.button?.label && point?.button?.href
							);

							if (hasValidButton) {
								return (
									<ul
										key={row?.id}
										className={styles["developer-inline-list"]}
									>
										{row?.points?.length > 0 && <li></li>}
										{row?.points?.map(
											(point) =>
												point?.button?.label &&
												point?.button?.href && (
													<li key={point.id}>
														<button
															onClick={() =>
																router.push(
																	point.button
																		.href
																)
															}
															className="btn btn-primary"
														>
															{point.button.label}
														</button>
													</li>
												)
										)}
									</ul>
								);
							} else {
								return (
									<ul
										key={row?.id}
										className={`${styles["developer-inline-list"]
											} ${index % 2 !== 0 &&
											`bg-one ${styles["developer-bg-list"]}`
											}`}
									>
										<li className="text-white bg-primary-gradient text-normal font-medium">
											{row?.title}
										</li>
										{row?.points?.map((point) => (
											<li
												key={point.id}
												className="text-black"
											>
												{point?.title}
											</li>
										))}
									</ul>
								);
							}
						} else {
							return (
								<ul
									key={row?.id}
									className={`${styles["developer-inline-list"]
										} ${index % 2 !== 0 &&
										`bg-one ${styles["developer-bg-list"]}`
										}`}
								>
									<li className="text-white bg-primary-gradient text-normal font-medium">
										{row?.title}
									</li>
									{row?.points?.map((point) => (
										<li
											key={point.id}
											className="text-black"
										>
											{point?.title}
										</li>
									))}
								</ul>
							);
						}
					})}
				</div>

				<Accordion
					defaultActiveKey={0}
					className={`d-sm-block d-md-none ${styles["accordion"]}`}
					onSelect={(accordionIndex) =>
						setActiveAccordionIndex(accordionIndex)
					}
				>
					<Row>
						<Col lg={6}>
							{mobileAccordions?.map(
								(mobileAccordionData, index) => (
									<Accordion.Item
										eventKey={index}
										key={index}
										className={`p-0 ${activeAccordionIndex === index
											? styles["active"]
											: ""
											} ${styles["accordion-item"]}`}
									>
										<Accordion.Header
											className={`${styles["developer-table"]} ${styles["acordion-developer-table"]} ${styles["column-table-4"]}`}
										>
											<ul
												className={
													styles[
													"developer-table-list"
													]
												}
											>
												<li
													className={
														styles[
														"developer-list-blue"
														]
													}
												>
													<div
														className={
															styles[
															"developer-list-box"
															]
														}
													>
														<div
															className={
																styles[
																"next-project-profile"
																]
															}
														>
															<Image
																src={toWebp(
																	`${baseUrl}${mobileAccordionData?.image?.data?.attributes?.url}`
																)}
																alt={
																	mobileAccordionData
																		?.image
																		?.data
																		?.attributes
																		?.name
																}
															/>
														</div>
														<span></span>
													</div>

													{mobileAccordionData.title}
												</li>
											</ul>
											<div
												className={
													styles[
													"developer-heading-close"
													]
												}
											>
												<p>
													{mobileAccordionData.title}
												</p>
												<Image
													src="/images/acordion-plus-icon.svg"
													alt="acordion-plus-icon"
												/>
											</div>
											<p></p>
										</Accordion.Header>
										<Accordion.Body
											className={styles["accordion-body"]}
										>
											<div
												className={
													styles["developer-table"]
												}
											>
												{data?.table_rows?.map(
													(row, rowIndex) => {
														if (rowIndex === 0) {
															return null;
														} else if (
															rowIndex + 1 ===
															data?.table_rows
																?.length &&
															row?.points?.[index]
																?.button?.id
														) {
															return (
																<ul
																	key={
																		row?.id
																	}
																	className={`${styles["developer-inline-list"]} ${styles["developer-btn-list"]}`}
																>

																	<li>
																		{row
																			?.points?.[
																			index
																		]
																			?.button
																			?.id && (
																				<button
																					onClick={() =>
																						router.push(
																							row
																								?.points?.[
																								index
																							]
																								?.button
																								?.href
																						)
																					}
																					className={`btn btn-primary ${styles["table-btn-primary"]}`}
																				>
																					{
																						row
																							?.points?.[
																							index
																						]
																							?.button
																							?.label
																					}
																				</button>
																			)}
																	</li>
																</ul>
															);
														} else {
															return (
																<ul
																	key={
																		row?.id
																	}
																	className={`${styles["developer-inline-list"]} ${styles["developer-bg-list"]}`}
																>
																	<li>
																		{
																			row?.title
																		}
																	</li>
																	<li>
																		{
																			row
																				?.points?.[
																				index
																			]
																				?.title
																		}
																	</li>
																</ul>
															);
														}
													}
												)}
											</div>
										</Accordion.Body>
									</Accordion.Item>
								)
							)}
						</Col>
					</Row>
				</Accordion>
			</Container>
		</section>
	);
};

export default Developer;
